<template>
  <div>
    <!-- <h2 class="font-weight-light mb-3">Añadir Sucursal</h2> -->
    <v-form ref="formulario">
      <v-text-field label="Nombre de la Sucursal" v-model="sucursal.name" :rules="requiredRules"></v-text-field>
      <v-checkbox label="Casa Matríz" color="primary" v-model="sucursal.main" :true-value="1" :false-value="0"></v-checkbox>
      <!--<v-text-field label="Dirección" v-model="sucursal.address" :rules="requiredRules"></v-text-field>-->
      <!-- <v-text-field label="Comuna"></v-text-field> -->
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field label="Direccion" v-model="sucursal.address" required readonly clearable @click="showLocationPicker" />
        </v-flex>
        <v-flex xs12>
          <v-text-field label="Teléfono 1" v-model="sucursal.phone1" :rules="phoneRules" prefix="(+56)" mask="# #### ####"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="Teléfono 2" v-model="sucursal.phone2" :rules="phoneRules2" prefix="(+56)" mask="# #### ####"></v-text-field>
        </v-flex>
      </v-layout>
      <div class="text-right" v-if="editing === true">
        <v-btn :loading="deleting" color="error" @click="deleteBranch">Eliminar</v-btn>
        <v-btn color="secondary" @click="cancelEdition">Cancelar</v-btn>
        <v-btn color="primary" :loading="loading" @click="saveEdition">Guardar</v-btn>
      </div>
      <div class="text-right" v-else>
        <v-btn color="primary" :loading="loading" @click="submit">Añadir Sucursal</v-btn>
      </div>
    </v-form>
    <kimsa-location-picker
            ref="locationPicker"
            :googleApiKey="mapTokens.google"
            :accessToken="mapTokens.mapBox"
            libraries="places,drawing"
            mapStyle="mapbox://styles/mapbox/streets-v11"
            country="CL"
            :center="center"
            v-on:confirm="onLocationSelect" />
  </div>
</template>
<script>
import CommuneSelector from '@/components/common/CommuneSelector'
import KimsaLocationPicker from '@/components/common/KimsaLocationPicker'

export default {
  props: {
    submitFn: {
      type: Function
    },
    editing: {
      type: Boolean,
      default: false
    },
    editFn: {
      type: Function
    },
    default: {
      type: Object
    },
    submitEditedFn: {
      type: Function
    },
    cancelFn: {
      type: Function
    }
  },
  components: {
    CommuneSelector,
    KimsaLocationPicker
  },
  data() {
    return {
      sucursal: {
        id: null,
        name: null,
        main: false,
        address: null,
        phone1: null,
        phone2: null,
        commune_id: null,
        latitude: "0",
        longitude: "0",
        users: []
      },
      deleting: false,
      requiredRules: [
          v => !!v || 'Campo requerido'
      ],
      phoneRules: [
          v => /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
      ],
      phoneRules2: [
          v => {
            if (!!v) {
              return /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
            } else {
              return true
            }
          }
      ],
    }
  },
  mounted() {
    if (this.default) {
      this.setDefault()
    } else {
      this.sucursal = {
        id: null,
        name: null,
        main: 0,
        address: null,
        phone1: null,
        phone2: null,
        latitude: "0",
        longitude: "0",
        users: []
      }
    }
  },
  computed: {
    center(){
      var vm = this
      if(!vm.sucursal.longitude || !vm.sucursal.latitude) return []
      return [
              vm.sucursal.longitude,
              vm.sucursal.latitude,
      ]
    },
    loading() {
      return this.$store.getters['branches/loading']
    },
    mapTokens(){
      return {
        google: process.env.VUE_APP_GMAPS_API_KEY,
        mapBox: process.env.VUE_APP_MAPBOX_TOKEN
      }
    },
  },
  watch:{
    default(){
      this.setDefault()
    }
  },
  methods: {
    async deleteBranch(){
      var vm = this
      vm.deleting = true
      vm.$emit('delete')
     setTimeout(function(){
       vm.deleting = false
     }, 1000)
    },
    setDefault(){
      this.default.latitude = Number(this.default.latitude)
      this.default.longitude = Number(this.default.longitude)
      this.sucursal = JSON.parse(JSON.stringify(this.default))
    },
    showLocationPicker(){
      this.$refs.locationPicker.show()
    },
    seleccionarComuna(comuna) {
      this.sucursal.commune_id = comuna.id
    },
    onLocationSelect(location){
      var vm = this
      vm.sucursal.address = location ? location.address : null
      vm.sucursal.latitude = location ? location.center[1] : null
      vm.sucursal.longitude = location ? location.center[0] : null
      vm.$refs.locationPicker.hide()
    },
    async submit() {
      if (!this.$refs.formulario.validate())
        return

      await this.submitFn(JSON.parse(JSON.stringify(this.sucursal)))
    },
    cancelEdition() {
      this.resetForm()
      this.cancelFn()
    },
    async saveEdition() {
      if (!this.$refs.formulario.validate())
        return

      this.editFn(JSON.parse(JSON.stringify(this.sucursal)))
    },
    resetForm() {
      this.$refs.formulario.reset()
    },
    setCommune(id) {
      this.sucursal.commune_id = id
      this.$refs.communeSelector.model = id
    }
  },
}
</script>

